import { ModuleWithProviders, NgModule } from '@angular/core';
import { LAYOUT_PAGE_TITLE } from '@spaq/core';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { CalendarViewPageComponent } from './pages';

@NgModule({
	imports: [SharedCommonModule, SharedComponentsModule],
	declarations: [CalendarViewPageComponent],
	exports: [CalendarViewPageComponent]
})
export class CalendarModule {
	static forRoot(): ModuleWithProviders<CalendarModule> {
		return {
			ngModule: CalendarModule,
			providers: [
				{
					provide: LAYOUT_PAGE_TITLE,
					useValue: new BehaviorSubject('Calendrier de perception')
				}
			]
		};
	}
}
